<template>
  <div>
    <b-table small striped hover
    @row-clicked="rowBankClickHandler"
    :items="banks"
    :fields="banksFields">
    </b-table>
    <b-row>
      <b-col>
        <b-button variant="success" style="float: right; width: 100px" @click.stop="selectBank">Ok</b-button>
      </b-col>
      <b-col sm="3">
        <b-button  variant="secondary" style="float: right; width: 100px" @click.stop="hideFormBank">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    userInfo: null
  },
  data () {
    return {
      selectedBank: null,
      banks: [],
      banksFields: [
        {key: 'bank_id', label: 'ID', sortable: true},
        {key: 'bic', label: this.$i18n.t('BIN'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true},
        {key: 'kschet', label: this.$i18n.t('Correspondent account'), sortable: true}
      ]
    }
  },
  methods: {
    rowBankClickHandler (row) {
      if (this.selectedBank) {
        this.selectedBank._rowVariant = ''
      }
      this.selectedBank = row
      this.$set(this.selectedBank, '_rowVariant', 'info')
    },
    selectBank () {
      if (!this.selectedBank) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select Bank'), 'Error')
        return
      }
      this.userInfo.bank_id = this.selectedBank.bank_id
      this.hideFormBank()
      this.$emit('load')
    },
    hideFormBank () {
      this.$emit('hideFormBank')
    }
  },
  async mounted () {
    this.banks = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_BANKS).then(response => { return response.data })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additional/formBank.vue